function IconInfo({
  className,
  fill = '#32B2E9',
}: {
  className?: string;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 0.0799561C7.36885 0.0799561 4.84651 1.12495 2.98507 2.98495C1.12507 4.8462 0.0800781 7.36863 0.0800781 9.99999C0.0800781 12.6313 1.12507 15.1536 2.98507 17.015C4.84632 18.875 7.36875 19.92 10.0001 19.92C12.6315 19.92 15.1537 18.875 17.0152 17.015C18.8752 15.1538 19.9201 12.6313 19.9201 9.99999C19.9201 7.36863 18.8752 4.84639 17.0152 2.98495C15.1539 1.12495 12.6315 0.0799561 10.0001 0.0799561ZM10.0001 18C7.87886 18 5.84395 17.1575 4.34379 15.6562C2.84254 14.1562 2.00005 12.1212 2.00005 9.99989C2.00005 7.87861 2.84254 5.84373 4.34379 4.34357C5.84379 2.84232 7.87883 1.99983 10.0001 1.99983C12.1214 1.99983 14.1563 2.84232 15.6564 4.34357C17.1577 5.84357 18.0002 7.87861 18.0002 9.99989C18.0002 12.1212 17.1577 14.1561 15.6564 15.6562C14.1564 17.1575 12.1214 18 10.0001 18Z"
        fill={fill}
      />
      <path d="M9.04004 9.67993H10.96V14.7999H9.04004V9.67993Z" fill={fill} />
      <path
        d="M10.96 6.15995C10.96 7.43995 9.04004 7.43995 9.04004 6.15995C9.04004 4.87995 10.96 4.87995 10.96 6.15995Z"
        fill={fill}
      />
    </svg>
  );
}

export default IconInfo;
